export const CallRealEstateAgent = 'CallRealEstateAgent'
export const EmailRealEstateAgent = 'EmailRealEstateAgent'
export const ChangeTheseValues = 'ChangeTheseValues'
export const CMARequest = 'CMARequest'
export const CMARequestSkipped = 'CMARequestSkipped'
export const CMARequestFinished = 'CMARequestFinished'
export const CMAQuestionAnswered = 'CMAQuestionAnswered'
export const NumbersLookRight = 'NumbersLookRight'
export const NightlyAirbnbClick = 'NightlyAirbnbClick'
export const NightlyVRBOClick = 'NightlyVRBOClick'
export const DIYUpdatePayments = 'DIYUpdatePayments'
export const NightlyUpdatePrice = 'NightlyUpdatePrice'
export const NightlyUpdateNights = 'NightlyUpdateNights'
export const NightlyLearnMore = 'NightlyLearnMore'
export const SaveMortgage = 'SaveMortgage'
export const AddMortgage = 'AddMortgage'
export const DeleteMortgage = 'DeleteMortgage'
export const KnownPMILoaded = 'KnownPMILoaded'
export const EstPMILoaded = 'EstPMILoaded'
export const InviteAnotherHomeowner = 'InviteAnotherHomeowner'
export const InterestPayMoreMonthly = 'InterestPayMoreMonthly'
export const AirDNARequest = 'AirDNARequest'
export const AirDNALoaded = 'AirDNALoaded'
export const AdditionalInfoPhoneAgent = 'AdditionalInfoPhoneAgent'
export const DirectMessage = 'DirectMessage'
export const LearnMore = 'LearnMore'
export const ModuleShown = 'ModuleShown'
export const AVMDiffLoad = 'AVMDiffLoad'
export const AVMDiffClicked = 'AVMDiffClicked'
export const NDStateWarnLoad = 'NDStateWarnLoad'
export const NDStateWarnTuneClick = 'NDStateWarnTuneClick'
export const NDStateLooksGoodClick = 'NDStateLooksGoodClick'
export const LowConfidenceWarnLoad = 'LowConfidenceWarnLoad'
export const LowConfidenceWarnTuneClick = 'LowConfidenceWarnTuneClick'
export const LowConfidenceLooksGoodClick = 'LowConfidenceLooksGoodClick'
export const HomePreviewLoaded = 'HomePreviewLoaded'
export const HomePreviewEmailEntered = 'HomePreviewEmailEntered'
export const HomePreviewSignUpComplete = 'HomePreviewSignUpComplete'
export const CoveredWhyShouldYouCareClick = 'CoveredWhyShouldYouCareClick'
export const CoveredRecommendHelpfulYes = 'CoveredRecommendHelpfulYes'
export const CoveredRecommendHelpfulNo = 'CoveredRecommendHelpfulNo'
export const CoveredExploreOptionsClick = 'CoveredExploreOptionsClick'
export const ScrolledIntoView = 'ScrolledIntoView'
export const TuneNavigateBack = 'TuneNavigateBack'
export const MortgageCoachNavigateBack = 'MortgageCoachNavigateBack'
export const InstantOfferNavigateBack = 'InstantOfferNavigateBack'
export const ViewCashoutFromWIN = 'ViewCashoutFromWIN'
export const ViewReliefFromWIN = 'ViewReliefFromWIN'
export const ViewShareFromWIN = 'ViewShareFromWIN'

export const EVENTS_LABELS = {
  EstimatedValueModule: 'EstimatedValueModule',
  PaidSoFarSection: 'PaidSoFarSection',
  HomeInsuranceModule: 'HomeInsuranceModule',
  RefiScenariosSection: 'RefiScenariosSection',
  PrincipalPaymentsSection: 'PrincipalPaymentsSection',
  PurchasingPowerModule: 'PurchasingPowerModule',
  CashOutModule: 'CashOutModule',
  ReferralSection: 'ReferralSection',
  ReverseMortgageSection: 'ReverseMortgageSection',
  PmiSection: 'PmiSection'
}

export const EVENTS_CATEGORIES = {
  [CallRealEstateAgent]: 1,
  [EmailRealEstateAgent]: 1,
  [ChangeTheseValues]: 3,
  [CMARequest]: 1,
  [CMARequestSkipped]: 1,
  [CMARequestFinished]: 1,
  [CMAQuestionAnswered]: 2,
  [NumbersLookRight]: 3,
  [NightlyAirbnbClick]: 1,
  [NightlyVRBOClick]: 1,
  [NightlyLearnMore]: 1,
  [DIYUpdatePayments]: 3,
  [NightlyUpdatePrice]: 3,
  [NightlyUpdateNights]: 3,
  [SaveMortgage]: 2,
  [AddMortgage]: 2,
  [DeleteMortgage]: 2,
  [KnownPMILoaded]: 1,
  [EstPMILoaded]: 1,
  [InviteAnotherHomeowner]: 1,
  [AirDNARequest]: 3,
  [AirDNALoaded]: 3,
  [AdditionalInfoPhoneAgent]: 1,
  [DirectMessage]: 1,
  [LearnMore]: 1,
  [ModuleShown]: 2,
  [AVMDiffLoad]: 2,
  [AVMDiffClicked]: 2,
  [NDStateWarnLoad]: 2,
  [NDStateWarnTuneClick]: 2,
  [NDStateLooksGoodClick]: 2,
  [LowConfidenceWarnLoad]: 2,
  [LowConfidenceWarnTuneClick]: 2,
  [LowConfidenceLooksGoodClick]: 2,
  [HomePreviewLoaded]: 1,
  [HomePreviewEmailEntered]: 1,
  [HomePreviewSignUpComplete]: 1,
  [CoveredWhyShouldYouCareClick]: 2,
  [CoveredRecommendHelpfulYes]: 2,
  [CoveredRecommendHelpfulNo]: 2,
  [CoveredExploreOptionsClick]: 2,
  [ScrolledIntoView]: 3,
  [TuneNavigateBack]: 2,
  [MortgageCoachNavigateBack]: 2,
  [InstantOfferNavigateBack]: 2,
  [ViewCashoutFromWIN]: 2,
  [ViewReliefFromWIN]: 2,
  [ViewShareFromWIN]: 2
}

export const HOME_FACTS_TRACKING_PROGRESS = {
  0: 'Ruler',
  20: 'Bedrooms',
  40: 'Bathrooms',
  60: 'Sq ft',
  80: 'Additional updates',
  100: 'Finished'
}
